import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AutenticacionStoreService } from '../../feature/autenticacion/store/autenticacion-store.service';
import { SweetAlertService } from '../services/sweet-alert.service';
import { LoginRequestService } from '../services/login-request.service';

import { SessionDto } from '../data/SessionDto';
import { constantes } from '../data/Constantes';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  public session$: Observable<SessionDto>;
  public session: SessionDto;
  public validoSession: boolean;

  constructor(
    private readonly sweetAlertService: SweetAlertService,
    private readonly loginRequestService: LoginRequestService,
    private readonly autenticacionStoreService: AutenticacionStoreService,
    private router: Router) {
    this.session$ = this.autenticacionStoreService.obtenerSession$();
    this.session = new SessionDto();
  }

  public redirect(flag: boolean): any {
    if (!flag) {
      this.sweetAlertService.sweetAlertCierreSesionGuardian();
    }
  }

  async isAuthenticatedUser(): Promise<boolean> {
    this.session$.subscribe({
      next: (store: SessionDto) => {

        this.session = store;
      }
    });
    return this.loginRequestService.validarSessionActiva(this.session?.codigousuario, this.session?.session).toPromise();
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isAuthenticated: any = await this.isAuthenticatedUser();

    if (['INT01'].includes(isAuthenticated.payload.code)){
      this.sweetAlertService.sweetAlertCierreSesionGuardian();
    }else{
      this.redirect(isAuthenticated.payload);
      return isAuthenticated.payload;
    }
  }

}


